import { Navigate, useLocation } from 'react-router-dom';

/**
 * LoginPage — kept as backward-compat redirect.
 * The new auth flow lives in <AuthOverlay /> mounted on the Landing page.
 * Anyone hitting /login is forwarded to /?auth=1 with the original "next" preserved.
 */
const LoginPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const next = params.get('next') || '/studio/dashboard';
  const target = `/?auth=1&next=${encodeURIComponent(next)}`;
  return <Navigate to={target} replace />;
};

export default LoginPage;
